import { render, staticRenderFns } from "./dithering.vue?vue&type=template&id=10d816c4&scoped=true&"
import script from "./dithering.vue?vue&type=script&lang=js&"
export * from "./dithering.vue?vue&type=script&lang=js&"
import style0 from "./dithering.vue?vue&type=style&index=0&id=10d816c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d816c4",
  null
  
)

export default component.exports